export interface PriceItem {
  content: string;
  baseFee: string;
  unit: string;
  fee: string;
  note: string;
}

export interface PriceGroup {
  name: string;
  subname?: string;
  items: PriceItem[];
  extras?: { label: string; value: string }[];
}

export interface PriceList {
  title: string;
  unitLabel: string;
  groups: PriceGroup[];
  footnotes: string[];
}

export const gasCorrosionPriceList: PriceList = {
  title: "ガス腐食試験・接触抵抗評価料金表",
  unitLabel: "単位：円",
  groups: [
    {
      name: "ガス腐食試験",
      subname: "温湿度定置運転",
      items: [
        { content: "シングルガス", baseFee: "36,000", unit: "1時間", fee: "1,450", note: "H2S・SO2・オゾン" },
        { content: "シングルガス", baseFee: "36,000", unit: "〃", fee: "1,730", note: "H2S・SO2 100ppm以上の高濃度 / NO2ガスシングル10ppm、Cl2ガスシングル1ppmまで / 設定温度+60℃以上" },
        { content: "2種混合ガス", baseFee: "48,000", unit: "1時間", fee: "2,320", note: "H2S・SO2の組み合わせ" },
        { content: "2種混合ガス", baseFee: "48,000", unit: "〃", fee: "2,600", note: "H2S・SO2・NO2・Cl2の組み合わせ" },
        { content: "3種混合ガス", baseFee: "60,000", unit: "1時間", fee: "3,190", note: "H2S・SO2・NO2の組み合わせ" },
        { content: "3種混合ガス", baseFee: "60,000", unit: "〃", fee: "3,470", note: "H2S・SO2・NO2・Cl2の組み合わせ" },
        { content: "4種混合ガス", baseFee: "78,000", unit: "1時間", fee: "3,520", note: "H2S・SO2・NO2・Cl2の組み合わせ" },
      ],
      extras: [
        { label: "サイクル運転(※1)", value: "温湿度定置運転の料金に加え、1時間あたり+1,000円" },
        { label: "プログラム運転(※2)", value: "温湿度定置運転の料金に加え、1時間あたり+1,500円" },
      ],
    },
    {
      name: "ガス腐食試験（大型試験槽使用）",
      subname: "温湿度定置運転",
      items: [
        { content: "シングルガス", baseFee: "36,000", unit: "1時間", fee: "2,600", note: "H2S・SO2等" },
        { content: "シングルガス", baseFee: "36,000", unit: "〃", fee: "3,040", note: "H2S・SO2 100ppm以上の高濃度 / NO2ガスシングル10ppm、Cl2ガスシングル1ppmまで / 設定温度+60℃以上" },
        { content: "2種混合ガス", baseFee: "48,000", unit: "1時間", fee: "3,470", note: "H2S・SO2の組み合わせ" },
        { content: "2種混合ガス", baseFee: "48,000", unit: "〃", fee: "3,900", note: "H2S・SO2・NO2・Cl2の組み合わせ" },
        { content: "3種混合ガス", baseFee: "60,000", unit: "1時間", fee: "4,490", note: "H2S・SO2・NO2の組み合わせ" },
        { content: "3種混合ガス", baseFee: "60,000", unit: "〃", fee: "4,920", note: "H2S・SO2・NO2・Cl2の組み合わせ" },
        { content: "4種混合ガス", baseFee: "78,000", unit: "1時間", fee: "4,950", note: "H2S・SO2・NO2・Cl2の組み合わせ" },
      ],
      extras: [
        { label: "サイクル運転(※1)", value: "温湿度定置運転の料金に加え、1時間あたり+2,000円" },
        { label: "プログラム運転(※2)", value: "温湿度定置運転の料金に加え、1時間あたり+3,000円" },
      ],
    },
    {
      name: "その他",
      items: [
        { content: "温湿度記録", baseFee: "0", unit: "1時間", fee: "50", note: "" },
        { content: "デジタルカメラ写真", baseFee: "1,730", unit: "1部", fee: "-", note: "サンプル投入時設置写真2枚" },
        { content: "通電しながらの試験", baseFee: "1,200", unit: "1時間", fee: "30", note: "消火フィルム代別途※3" },
      ],
    },
    {
      name: "接触抵抗測定",
      items: [
        { content: "エリア分析", baseFee: "12,000", unit: "1point", fee: "450", note: "MS7500 システム1" },
        { content: "荷重変動", baseFee: "12,000", unit: "1point", fee: "1,200", note: "MS7500 システム2（増1,200/増減2,000）" },
        { content: "摺動評価", baseFee: "12,000", unit: "1摺動", fee: "300", note: "MS7500 システム3" },
        { content: "フレッティング・クリープ", baseFee: "12,000", unit: "100秒", fee: "1,400", note: "MS7500 システム4" },
      ],
    },
  ],
  footnotes: [
    "※1 サイクル運転：温湿度や時間の条件変更に規則性を持たせ、そのサイクルを一定回数繰り返す。",
    "※2 プログラム運転：温湿度や時間の条件変更を不規則に設定する。",
    "消費税は含まれておりません。",
    "上記試験料金表以外のガス腐食試験につきましては、別途標準ガス料金が必要となります。",
    "・接触抵抗分析例：エリア分析（荷重20g・100ポイント）、定位置荷重変動（0〜20gまで0.1g分解能・0.02mm*10移動）、摺動評価（20gまで移動距離2mm・1000回）",
    "・サンプルの重量や個数により追加料金を頂戴いたします。",
    "※3 消火フィルム：通電および発熱を伴うサンプルの評価試験を実施するにあたり安全対策の一環として使用いたします。",
  ],
};

export const envTestPriceList: PriceList = {
  title: "その他環境試験料金表",
  unitLabel: "単位：円",
  groups: [
    {
      name: "その他環境試験",
      items: [
        { content: "高温放置試験", baseFee: "16,000~", unit: "1時間", fee: "400~700", note: "+40℃〜200℃" },
        { content: "耐湿度試験", baseFee: "16,000~", unit: "1時間", fee: "700~1,000", note: "-40℃〜100℃" },
        { content: "プレッシャクッカー", baseFee: "33,000~", unit: "1時間", fee: "1,300~2,600", note: "" },
        { content: "冷熱衝撃試験", baseFee: "38,000~", unit: "1時間", fee: "1,300~2,600", note: "" },
        { content: "振動試験（正弦波、衝撃波、ランダム波）", baseFee: "55,000~", unit: "1時間", fee: "6,500~", note: "" },
        { content: "複合振動試験（正弦波、衝撃波、ランダム波）", baseFee: "55,000~", unit: "1時間", fee: "7,900~", note: "温湿度サイクル+振動試験" },
        { content: "温水浸試験", baseFee: "8,000~", unit: "1時間", fee: "400", note: "" },
        { content: "塩水浸試験", baseFee: "8,000~", unit: "1時間", fee: "400", note: "" },
        { content: "塩水噴霧試験", baseFee: "31,600~", unit: "1個/24時間以内", fee: "-", note: "24h増毎に+9,000円、2試料目〜+2,400円 / JIS Z 2371など" },
        { content: "薬品浸漬試験", baseFee: "8,000~", unit: "1時間", fee: "260~", note: "溶剤種類などにより異なります" },
        { content: "塵埃試験（JIS D 0207）", baseFee: "96,000~", unit: "1個/8時間", fee: "-", note: "8種 / ダスト6種、11種等は別途要相談" },
        { content: "塩酸曝気試験", baseFee: "16,000~", unit: "1時間", fee: "1,000", note: "塩酸濃度10wt%など" },
        { content: "硝酸曝気試験", baseFee: "55,000", unit: "1時間", fee: "1,000", note: "廃液処理手数料12,000円別途" },
        { content: "アンモニア試験", baseFee: "55,000", unit: "1時間", fee: "1,000~", note: "CES M 0010に準拠" },
      ],
    },
  ],
  footnotes: [
    "消費税は含まれておりません。",
  ],
};